import { Notification } from '@vfde-brix/ws10/notification';
import { getCMSConfig } from '../../../util/cms';
import { LMModuleHtmlId, LmsHtmlId } from '../../../enums/elementId';
import { LmsErrorNoti } from '../enum';
import { LmsResponse } from '../interface';
import { toggleElementsVisibilityById, toggleElementVisibilityById } from '@vfde-brix/ws10/core';

const showLmsSuccessNotification = (notification: Notification) => {
    const content = getCMSConfig()?.lm?.result.success;

    notification.update({
        stdHeadline: content?.headline,
        txtContent: content?.subline,
    });

    toggleElementsVisibilityById([
        LmsHtmlId.WRAPPER_FORM_LMS,
        LmsHtmlId.WRAPPER_NOTIFICATION_ERROR,
    ], false);
    toggleElementVisibilityById(LmsHtmlId.WRAPPER_NOTIFICATION_RESULT, true);
};

const showLmsErrorNotification = (notification: Notification, type: LmsErrorNoti) => {
    const config = getCMSConfig()?.lm?.result;

    if (!config) {
        return;
    }

    const props = notification.getProperties();

    if (type === LmsErrorNoti.GENERAL) {
        props.stdHeadline = config.backendError.headline;
        props.txtContent = config.backendError.subline;
    } else {
        props.stdHeadline = '';
        props.txtContent = config.valueMissing;
    }

    notification.update(props);

    toggleElementVisibilityById(LmsHtmlId.WRAPPER_NOTIFICATION_ERROR, true);
};

export const showLmsResult = (
    successNoti: Notification | null,
    errorNoti: Notification | null,
    result?: LmsResponse,
) => {
    if (!successNoti || !errorNoti) {
        return;
    }

    if (result === undefined) {
        toggleElementVisibilityById(LmsHtmlId.WRAPPER_FORM_LMS, true);
        toggleElementVisibilityById(LmsHtmlId.WRAPPER_NOTIFICATION_RESULT, false);
        return;
    }

    const { status, email, firstName, lastName } = result;

    if (status) {
        // render success notification
        showLmsSuccessNotification(successNoti);
        toggleElementVisibilityById(LMModuleHtmlId.MODULE_CONTAINER, false);
        toggleElementVisibilityById(LMModuleHtmlId.MODULE_SUCCESS_CONTAINER);
        return;
    }

    if (email || firstName || lastName) {
        // form error
        showLmsErrorNotification(errorNoti, LmsErrorNoti.MISSING_INPUT);
        return;
    }

    // render generic error
    showLmsErrorNotification(errorNoti, LmsErrorNoti.GENERAL);
};
